import { colorsColumns, colorsRows } from '../../constants/colors';
import {
  SET_CLEAR_ALL_STATE,
  SET_DATA,
  SET_ERROR_RSO,
  SET_GET_FILE_RSO,
  SET_LOADING_FILE_RSO,
  SET_FILE,
  SET_EXCEL_PREVIEW_DATA,
  SET_EXCEL_PREVIEW_COLUMNS,
  SET_COLUMN_LABELS,
  SET_HIGHLIGHTED_COLUMNS,
  CLEAR_HIGHLIGHTED_COLUMNS,
  SET_HIGHLIGHTED_ROWS,
  CLEAR_HIGHLIGHTED_ROWS,
  SET_VALUE_FORM,
  SET_ROW_LABELS,
} from '../actions/actionsTypes';
import { highlightedColumnsHandler } from './handlers';

const initialState = {
  valueForm: {},
  file: null,
  data: [],
  loadingFileRSO: false,
  getFileRso: null,
  errorRso: null,
  excelPreviewData: [],
  excelPreviewColumns: [],
  columnLabels: [],
  rowLabels: [],
  highlightedColumns: colorsColumns,
  highlightedRows: colorsRows,
};

const rsoImportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_DATA:
      return {
        ...state,
        data: payload,
      };
    case SET_FILE:
      return {
        ...state,
        file: payload,
      };
    case SET_EXCEL_PREVIEW_DATA:
      return {
        ...state,
        excelPreviewData: payload,
      };
    case SET_EXCEL_PREVIEW_COLUMNS:
      return {
        ...state,
        excelPreviewColumns: payload,
      };
    case SET_LOADING_FILE_RSO:
      return {
        ...state,
        loadingFileRSO: payload,
      };
    case SET_GET_FILE_RSO:
      return {
        ...state,
        getFileRso: payload,
      };
    case SET_ERROR_RSO:
      return {
        ...state,
        errorRso: payload,
      };
    case SET_COLUMN_LABELS:
      return {
        ...state,
        columnLabels: payload,
      };
    case SET_HIGHLIGHTED_COLUMNS: {
      return highlightedColumnsHandler({ state, value: payload });
    }
    case CLEAR_HIGHLIGHTED_COLUMNS:
      return {
        ...state,
        highlightedColumns: state.highlightedColumns.map((item) => ({
          ...item,
          column: [],
        })),
      };
    case SET_HIGHLIGHTED_ROWS: {
      const { name, rows } = payload;

      const updated = [...state.highlightedRows];
      const indexUpdate = updated.findIndex((c) => c.name === name);
      updated[indexUpdate] = { ...updated[indexUpdate], rows };

      return {
        ...state,
        highlightedRows: updated,
      };
    }
    case CLEAR_HIGHLIGHTED_ROWS:
      return {
        ...state,
        highlightedRows: colorsRows,
      };

    case SET_VALUE_FORM:
      return {
        ...state,
        valueForm: { ...payload },
      };
    case SET_ROW_LABELS:
      return {
        ...state,
        rowLabels: payload,
      };
    case SET_CLEAR_ALL_STATE:
      return { ...initialState };
    default:
      return {
        ...state,
      };
  }
};

export default rsoImportReducer;
